module.exports = __webpack_public_path__ + "img/Blue-comingsoon.69ba681d.png";